import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';

export const fetchAringToday = () => ({
  type: actionsTypes.FETCH_AIRING_TODAY,
  payload: API.fetch_airing_today_tv()
});

export const fetchOnTheAir = () => ({
  type: actionsTypes.FETCH_ON_THE_AIR,
  payload: API.fetch_on_the_air()
});

export const fetchPopularTv = () => ({
  type: actionsTypes.FETCH_POPULAR_TV,
  payload: API.fetch_popular_tv()
});

export const fetchTopRatedTv = () => ({
  type: actionsTypes.FETCH_TOP_RATED_TV,
  payload: API.fetch_top_rated_tv()
});
